export default "__VITE_ASSET__BzRaQexy__"